import { Menu, MenuItem, Spinner } from '@blueprintjs/core';
import { ItemListRendererProps } from '@blueprintjs/select';
import * as React from 'react';

import { SelectItem } from 'bones/utils/select/types';

export const loadingItemListRenderer =
  <
    SubItemType extends SelectItem | null,
    ItemType extends SelectItem<SubItemType>
  >({
    loadingTestId,
  }: {
    loadingTestId?: string;
  }) =>
  // eslint-disable-next-line react/display-name
  ({ itemsParentRef }: ItemListRendererProps<ItemType>) =>
    (
      <Menu ulRef={itemsParentRef}>
        <MenuItem data-testid={loadingTestId} text={<Spinner />} />
      </Menu>
    );
